/**
* Component: AssetRecordTab.jsx
* Description: This component is the child component of AssetViews.jsx,It is utilized for listing the History Maintainance Details,Historical Cost and Asset Audit trail in the grid.
*/
import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import CustomAgGrid from "../commoncomponents/CustomAgGrid";
import { Button, Grid, Stack } from '@mui/material';
import { Dialog, DialogActions, DialogContent } from '@mui/material';
import CustomTextField from "../commoncomponents/CustomTextField";
import { useDispatch, useSelector } from 'react-redux';
import { newHisotricalCostData } from '../../redux/actions/assetActions';
import axios from 'axios';
import { BemsGraph, FemsGraph, MasterGraph } from '../../utility/apiURLS';
import CustomDialog from '../commoncomponents/CustomDialog';
import { getAuthToken, getFacilityId, getcompanyId } from '../../utility/tokenUtility';
import AssetRepository from '../../api/repositories/assetRepository';
import CustomSelectInput from '../commoncomponents/CustomSelectInput';
import dayjs from 'dayjs';
import { useLocation, useNavigate } from 'react-router-dom';
import RefreshExportButtons from '../commoncomponents/RefreshExportButtons';

function AssetRecordTab({ rows }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [value, setValue] = useState('1');
  const [openDialog, setOpenDialog] = useState(false);
  const gridRows = rows;
  const [gridApi, setGridApi] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [rowToDelete, setRowToDelete] = useState({});
  const [selectedRow, setSelectedRow] = useState(null); // For tracking the row being edited
  const [auditTrail, setAuditTrail] = useState([]);
  const historicalAssetCostData = useSelector((state) => state.newHisotricalCostData);
  const assetCategoryType = location.state?.assetCategoryType;

  //To set the field value should be empty when the user create a new historical cost asset data
  const initialState = {
    historicalmaintenanceyear: '',
    breakdowncost: '',
    ppmcost: '',
    totalmaintenancecost: '',
    remarks: ''
  };

  //Asset Maintenance History grid data from props(rows)
  const assetMaintenanceHistoryData = assetCategoryType === "/assetsFEM" ? gridRows[0]?.femassethistorymaintenances : gridRows[0]?.bemassethistorymaintenances;
  const [assetMaintenancedata, setassetMaintenancedata] = useState(assetMaintenanceHistoryData);
  const [maintananceHistory, setMaintananceHistory] = useState([]);
  const [testinghistory, setTestingHistory] = useState([]);
  const [contracthistory, setContractHistory] = useState([]);
  const [textfield, setTextField] = useState({ ...historicalAssetCostData } || initialState);
  const [maintananceYearOptions, setMaintanaceYearOptions] = useState([]);
  const [disableAddbtn, setDisableAddbtn] = useState(true);
  const dispatch = useDispatch();

  //Handling the form dialog box
  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRow(null); // Reset the selectedRow when closing the dialog
  };

  // maintenance history columns names
  const maintananceHistoryColDef = [
    {
      field: "workorderno", headerName: "WO NO", flex: 1, minWidth: 200,
      cellRenderer: (params) => {

        return (
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              navigate('/workorder')
            }}
            style={{ textDecoration: 'underline', color: '#1a73e8' }}
          >
            {params.value}
          </a>
        );
      }
    },
    { field: "workorderdate", headerName: "Wo Date", flex: 1, minWidth: 200 },
    //  { field: "workordertype", headerName: "Wo Type", flex: 1, minWidth: 200 },
    { field: "locationdesc", headerName: "Location", flex: 1, minWidth: 200 },
    { field: "departmentdesc", headerName: "Department", flex: 1, minWidth: 200 },
    { field: "responsetype", headerName: "Repair Type", flex: 1, minWidth: 200 },
    { field: "startdate", headerName: "Start Date", flex: 1, minWidth: 200 },
    { field: "enddate", headerName: "End Date", flex: 1, minWidth: 200 },
    // { field: "sparepartscost", headerName: "Parts", flex: 1, minWidth: 200, cellStyle: { textAlign: "right" } },
    { field: "breakdowncost", headerName: "Break Down Cost In RM", flex: 1, minWidth: 200, cellStyle: { textAlign: "right" } },
    { field: "ppmcost", headerName: "PPM Cost In RM", flex: 1, minWidth: 200, cellStyle: { textAlign: "right" } },
    { field: "totalwocost", headerName: "Total Cost In RM", flex: 1, minWidth: 200, cellStyle: { textAlign: "right" } },
    { field: "downtimehours", headerName: "DownTime ", flex: 1, minWidth: 200 },
    { field: "workgroup", headerName: "Work Group", flex: 1, minWidth: 200 },
    { field: "requestdetails", headerName: "WO Description", flex: 1, minWidth: 200 },
    { field: "actionTaken", headerName: "Action Taken ", flex: 1, minWidth: 200 },
  ];

  const testinghistoryColDef = [
    { field: "workorderno", headerName: "T&C NO", flex: 1, minWidth: 200 },
    { field: "workorderdate", headerName: "T&C  End Date", flex: 1, minWidth: 200 },
    { field: "typecode", headerName: "Type Code", flex: 1, minWidth: 200, cellStyle: { textAlign: "right" } },
    { field: "requestdetails", headerName: "Asset Description", flex: 1, minWidth: 200 },
    { field: "locationdesc", headerName: "Location", flex: 1, minWidth: 200 },
    { field: "workgroup", headerName: "Work Group", flex: 1, minWidth: 200 }

  ];
  // historical cost column names
  const historicalAssetColDefs = [
    { field: "historicalmaintenanceyear", headerName: "Maintenance Cost Year", flex: 1, minWidth: 200, cellStyle: { textAlign: "right" } },
    { field: "breakdowncost", headerName: "Break Down Cost in RM", flex: 1, minWidth: 200, valueGetter: (params) => params?.data?.breakdowncost ? parseFloat(params?.data?.breakdowncost || 0)?.toFixed(2) : '', cellStyle: { textAlign: "right" } },
    { field: "ppmcost", headerName: "PPM Cost in RM", flex: 1, minWidth: 200, valueGetter: (params) => params?.data?.ppmcost ? parseFloat(params?.data?.ppmcost || 0)?.toFixed(2) : '', cellStyle: { textAlign: "right" } },
    { field: "totalmaintenancecost", headerName: "Total Maintenance Cost", flex: 1, minWidth: 200, valueGetter: (params) => params?.data?.totalmaintenancecost ? parseFloat(params?.data?.totalmaintenancecost || 0)?.toFixed(2) : '', cellStyle: { textAlign: "right" } },
    { field: "remarks", headerName: "Remarks", flex: 1, minWidth: 200, wrapHeaderText: false },
  ];

  // asset audit trail column names
  const assetAuditColDefs = [
    { field: "audittrailid", headerName: "Audit Trail Id", minWidth: 120, wrapHeaderText: false },
    { field: "assetdesc", headerName: "Asset Description", minWidth: 230, wrapHeaderText: false },
    // { field: "assetcategory", headerName: "Asset Category", flex: 1, minWidth: 200 },
    // { field: "location", headerName: "Current Location", flex: 1, minWidth: 200 },
    // { field: "assetstatus", headerName: "Asset Status", flex: 1, minWidth: 200 },
    { field: "modifiedfieldname", headerName: "Modified Field Name", minWidth: 350, wrapHeaderText: false },
    { field: "modifiedbyName", headerName: "Modified By", minWidth: 230, wrapHeaderText: false },
    { field: "modifieddate", headerName: "Modified Date & Time", minWidth: 230, wrapHeaderText: false },
  ];


  const contracthistoryColDef = [
    { field: "contractno", headerName: "Contract No", flex: 1 },
    { field: "vendorname", headerName: "Vendor Name", flex: 1 },
    { field: "startdateformate", headerName: "Start Date", flex: 1 },
    { field: "enddateformate", headerName: "End Date", flex: 1 },
    { field: "status", headerName: "Status", flex: 1 },
    { field: "totalcontractvalue", headerName: "Total Contract Value", flex: 1 }

  ];

  //Handling the tab change value
  const handleChange = (event, newValue) => {
    console.log(newValue, "newvalue");

    setValue(newValue);
  };

  //To fetch the maintanance year options from API
  const fetchYearOptions = async (companyId, facilityId) => {
    try {
      const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
      const config = {
        headers: {
          Authorization: `Bearer ${token}`, // Attach bearer token to request header
        },
      };
      const yearOptions = await axios.get(`${MasterGraph}/api/masters/GetMasters/${companyId}/${facilityId}`, config);
      setMaintanaceYearOptions(
        yearOptions?.data?.masmaintenanceyears
          ?.map((item) => ({ label: `${item.maintyearvalue}` }))
          ?.sort((a, b) => b.label.localeCompare(a.label))
      );
    } catch (error) {
      console.log(`Failed to fetch year: ${error.message}`);
    }
  };

  // Get the facility id from local storage
  const facilityId = getFacilityId('facilityId');

  // Get the company id from local storage
  const companyId = getcompanyId('companyId');

  useEffect(() => {
    fetchYearOptions(companyId, facilityId); //Rendering the year options when the user maintance year field
  }, [textfield?.historicalmaintenanceyear]);


  //onchange for the field values
  const handleOnchangeforCustomfield = (value, name) => {

    setTextField((prev) => {
      const newState = { ...prev, [name]: value };

      //Dynamically changing the total cost value breakdowntcost + ppmcost =totalmaintanancecost
      if (name === "breakdowncost" || name === "ppmcost") {
        const breakdowncost = parseFloat(newState?.breakdowncost) || 0;
        const ppmcost = parseFloat(newState?.ppmcost) || 0;
        const totalCost = breakdowncost + ppmcost;
        newState.totalmaintenancecost = totalCost;
      }

      if ((newState?.historicalmaintenanceyear) && (newState?.breakdowncost > 0 || newState?.ppmcost > 0)) {
        setDisableAddbtn(false);
      }
      else {
        setDisableAddbtn(true);
      }

      return newState; //To set the new state totalcost 
    });
  };

  //To get the assetID,assetNo,assetDesc for save the history cost
  const selectedAssetDetail = useSelector((state) => state.gridValues?.selectedGridData?.values);
  const assetId = selectedAssetDetail?.assetId || location.state?.id;

  const getAllHistoryCostResponse = async () => {
    const response = await AssetRepository.getAllHistoricalAssetDetail(assetCategoryType, assetId);
    setassetMaintenancedata(response);
  }

  const getAssetMaintanceHistory = async () => {
    const responseSheduled = await AssetRepository.getSheduledList(assetCategoryType, assetId);
    const responseUnsheduled = await AssetRepository.getUnSheduldedList(assetCategoryType, assetId);
    const responseRoutineinspection = await AssetRepository.getRoutineInspectionList(assetCategoryType, assetId);
    const response = responseSheduled && responseUnsheduled && responseRoutineinspection ? [...responseSheduled, ...responseUnsheduled, ...responseRoutineinspection] : responseSheduled ? responseSheduled : responseUnsheduled ? responseUnsheduled : [];
    const modifyDateFormat = response?.map((item) => (
      {
        ...item,
        workorderdate: item?.workorderdate ? dayjs(item.workorderdate).format("DD/MM/YYYY") : "",
        startdate: item?.startdate ? dayjs(item.startdate).format("DD/MM/YYYY") : "",
        enddate: item?.enddate ? dayjs(item.enddate).format("DD/MM/YYYY") : "",
      }));
    setMaintananceHistory(modifyDateFormat);
  }

  const gettestingandcommission = async () => {
    const testing = await AssetRepository.gettestingandcommissionhistory(assetCategoryType, assetId);

    const response = testing;
    const modifyDateFormat = response?.map((item) => (
      {
        ...item,
        workorderdate: dayjs(item?.workorderdate).format("DD/MM/YYYY"),
      }));
    setTestingHistory(modifyDateFormat);
  }



  const getcontracthistory = async () => {
    const response = await AssetRepository.getcontracthistorydetails(assetCategoryType, assetId);
    //  console.log(response, "response");

    const contractdate = response?.map((item) => {
      if (item?.id) {

        return {
          ...item,
          startdateformate: dayjs(item.startdate).format("DD/MM/YYYY"),
          enddateformate: dayjs(item.enddate).format("DD/MM/YYYY"),
        };

      } else {
        return {};
      }


    });
    setContractHistory(contractdate);

  };

  const changeFieldName = (name) => {
    const splitNames = name?.split(",");
    const assetLabels = {
      rentalStatus: "Rental Status",
      tcNo: "T&C No",
      tcOldNo: "T&C Old No",
      oldAssetNo: "Old Asset No",
      assetClassification: "Asset Classification",
      financeAssetNo: "Finance Asset No",
      assetDescription: "Asset Description",
      typeCodeDescription: "Type Code Description",
      typecode: "Type Code",
      locationNo: "Location No",
      locationName: "Location Name",
      userDepartment: "User Department",
      departmentDescription: "Department Description",
      criticality: "Criticality",
      workGroup: "Work Group",
      ppmRequired: "PPM Required",
      ppmStatus: "PPM Status",
      parentAssestNo: "Parent Asset No",
      description: "Description",
      reason: "Reason",
      make: "Make",
      brand: "Brand",
      model: "Model",
      serialNo: "Serial No",
      engineNo: "Engine No",
      chassisNo: "Chassis No",
      registrationNo: "Registration No",
      manufacturer: "Manufacturer",
      buildupArea: "Built-up Area (Sq.m)",
      footPrint: "Foot Print",
      landArea: "Land Area (Sq.m)",
      capacity: "Capacity",
      assetStatus: "Asset Status",
      lifeSpan: "Life Span(yrs)",
      purchaseOrderNo: "Purchase Order No",
      purchaseCost: "Purchase Cost in RM",
      purchaseFlag: "Purchase Flag",
      warrantyStartDate: "Warranty Start Date",
      warrantyEndDate: "Warranty End Date",
      commissioningDate: "Commissioning Date",
      accessories: "Accessories",
      underWaranty: "Under waranty",
      vendor: "Vendor",
      cumulativePartCost: "Cumulative Part Cost in (RM)",
      lastScheduledWorkOrder: "Last Scheduled Work Order",
      lastUnscheduledWorkOrder: "Last Unscheduled Work Order",
      depreciationValue: "Depreciation value/ Year in RM",
      assetTransferCategory: "Asset Transfer Category",
      assetTransferDepartment: "Asset Transfer Department"
    };

    if (splitNames?.length > 1) {
      let labels = '';
      splitNames.map((item) => {
        let trimItem = item.trim();
        labels = labels ? `${labels}, ${assetLabels[trimItem] || trimItem}` : `${assetLabels[trimItem] || trimItem}`;
      });
      return labels;
    } else {
      return assetLabels[name] || name;
    }
  }

  const getAuditTrail = async () => {
    const response = await AssetRepository.getAuditTrail(assetCategoryType, assetId);
    const modifyDateFormat = response?.map((item, index) => (
      {
        ...item,
        audittrailid: `${index + 1}`,
        modifieddate: dayjs(item?.modifieddate).format("DD/MM/YYYY hh:mm:ss A"),
        location: `${item?.locationcode} - ${item?.locationdesc}`,
        modifiedfieldname: changeFieldName(item?.modifiedfieldname)
      }
    ));
    setAuditTrail(modifyDateFormat);
  }

  useEffect(() => {
    getAllHistoryCostResponse();
    getAssetMaintanceHistory();
    gettestingandcommission();
    getcontracthistory();
    getAuditTrail();
  }, []);

  const formSubmit = async () => {
    let assetno = selectedAssetDetail?.assetno || selectedAssetDetail?.assetNo;
    let assetdesc = selectedAssetDetail?.assetdesc;
    dispatch(newHisotricalCostData(textfield));
    const historicalmaintenanceyear = textfield?.historicalmaintenanceyear?.label;
    if (selectedRow) {

      const id = selectedRow?.id;
      const femorbem = assetCategoryType === '/assetsFEM' ? "FemassetregisterId" : "BemassetregisterId";
      const updateCostPayload = { ...textfield, [femorbem]: assetId, historicalmaintenanceyear, id, timestamp: selectedRow?.timestamp || "" };

      // Update existing historical cost
      await AssetRepository.editHistoricalcostData(assetCategoryType, selectedRow?.id, updateCostPayload);
      //Call the GetAll API to get the Updated historical cost data
      getAllHistoryCostResponse();
    } else {
      let assetregister = { id: assetId, assetno: assetno, assetdesc: assetdesc };
      const femorbem = assetCategoryType === '/assetsFEM' ? "femassetregister" : "bemassetregister";
      const historicalCostPayload = { ...textfield, [femorbem]: assetregister, historicalmaintenanceyear };

      // create new historical cost
      await AssetRepository.addHistoricalCost(assetCategoryType, historicalCostPayload);
      //Call the GetAll API to get the Updated historical cost data
      getAllHistoryCostResponse();
    }

    handleCloseDialog(); // when the form submit means the form dialog box should  be close
    setTextField(initialState); //when the form submit means the form should be empty
  };

  //Handing the edit option when the user click the specific row, get the all details in form
  const handleEdit = async (selectedrow) => {
    setSelectedRow(selectedrow);
    setOpenDialog(true);
    const response = await AssetRepository.gethistoricalAssetDetail(assetCategoryType, selectedrow?.id);
    const { breakdowncost, ppmcost, totalmaintenancecost, historicalmaintenanceyear, timestamp, remarks } = response;
    setTextField({
      breakdowncost: breakdowncost ? parseFloat(breakdowncost)?.toFixed(2) : '',
      ppmcost: ppmcost ? parseFloat(ppmcost)?.toFixed(2) : '',
      totalmaintenancecost: totalmaintenancecost,
      remarks: remarks || '',
      historicalmaintenanceyear: historicalmaintenanceyear ? { label: String(historicalmaintenanceyear) } : ""
    });
    const newHisotricaldata = { breakdowncost: breakdowncost, ppmcost: ppmcost, totalmaintenancecost: totalmaintenancecost, historicalmaintenanceyear: historicalmaintenanceyear, timestamp: timestamp, remarks: remarks || '' };
    dispatch(newHisotricalCostData(newHisotricaldata));
  };

  //handling the delete dialog box
  const handleDelete = (row) => {
    setRowToDelete(row);
    setDeleteDialogOpen(true);
  };

  //when the user click the Add button lets show the popup
  const newlyAddHistoricalCost = () => {
    setDisableAddbtn(true);
    setOpenDialog(true);
    setTextField(initialState);
  }

  //Confirm delete functionality API call
  const confirmDelete = async () => {
    const femorbem = assetCategoryType === '/assetsFEM' ? "femassethistorymaintenances" : "bemassethistorymaintenances";
    const checkGraph = assetCategoryType === '/assetsFEM' ? FemsGraph : BemsGraph;
    try {
      const token = getAuthToken("id_token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      if (!rowToDelete || !rowToDelete?.id) {
        return;
      }
      await axios.delete(`${checkGraph}/api/${femorbem}/${rowToDelete?.id}`, config);
      const updatedRows = assetMaintenancedata.filter((row) => {
        return row?.id !== rowToDelete?.id
      });

      setassetMaintenancedata(updatedRows);
      //Call the GetAll API to get the Updated historical cost data
      getAllHistoryCostResponse();
    } catch (error) {
      if (error?.response && error?.response?.status === 400) {
        setErrorMessage("Unable to delete the history. Please try again.");
      } else {
        setErrorMessage("An error occurred while deleting the history. Please try again.");
      }
    } finally {
      setDeleteDialogOpen(false);
      setRowToDelete({});
    }
  };

  const fetchMaintananceHistoryExportdata = () => {
    setMaintananceHistory(maintananceHistory);
  };

  const fetchtestinghistoryExportdata = () => {
    setTestingHistory(testinghistory);
  };

  const fetchcontracthistoryExportdata = () => {
    setContractHistory(contracthistory);
  };

  const fetchMaintananceExportdata = () => {
    setassetMaintenancedata(assetMaintenancedata);
  };

  const fetchAuditTrailExportdata = () => {
    setAuditTrail(auditTrail);
  };

  const handleRefreshMaintananceHistory = () => {
    setMaintananceHistory(maintananceHistory);
    setTestingHistory(testinghistory);
    setContractHistory(contracthistory);
  };

  const handleRefreshAssetMaintanance = () => {
    setassetMaintenancedata(assetMaintenancedata);
  };

  const handleRefreshAuditTrail = () => {
    setAuditTrail(auditTrail);
  };


  return (
    <Box sx={{ width: '100%', typography: 'body1' }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList onChange={handleChange} aria-label="Asset record tabs">
            <Tab label="Maintenance History" value="1" />
            <Tab label="T&C History" value="4" />
            <Tab label="Historical Cost" value="2" />
            <Tab label="Audit Trail" value="3" />
            <Tab label="Contract History" value="6" />
          </TabList>
        </Box>
        <TabPanel value="1">
          <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ width: '100%' }}>
            <Box></Box>
            <RefreshExportButtons
              exportFunction={fetchMaintananceHistoryExportdata}
              exportData={maintananceHistory}
              refData={gridApi}
              handleRefresh={handleRefreshMaintananceHistory}
              title={`Maintanance History ${assetCategoryType === "/assetsFEM" ? "FEMS" : "BEMS"}`}
            />
          </Stack>

          <CustomAgGrid rows={maintananceHistory} columns={maintananceHistoryColDef} setGridApi={setGridApi} />
        </TabPanel>
        <TabPanel value="4">
          <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ width: '100%' }}>
            <Box></Box>
            <RefreshExportButtons
              exportFunction={fetchtestinghistoryExportdata}
              exportData={testinghistory}
              refData={gridApi}
              handleRefresh={handleRefreshMaintananceHistory}
              title={`T&C History ${assetCategoryType === "/assetsFEM" ? "FEMS" : "BEMS"}`}
            />
          </Stack>

          <CustomAgGrid rows={testinghistory} columns={testinghistoryColDef} setGridApi={setGridApi} />
        </TabPanel>
        <TabPanel value="2">

          <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ width: '100%' }}>
            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', marginRight: "20px", marginBottom: "10px" }}>
              <Button variant='contained' data-testid="addButton" onClick={() => newlyAddHistoricalCost()}>Add</Button>
            </Grid>
            <RefreshExportButtons
              exportFunction={fetchMaintananceExportdata}
              exportData={assetMaintenancedata}
              refData={gridApi}
              handleRefresh={handleRefreshAssetMaintanance}
              title={`Historical Cost ${assetCategoryType === "/assetsFEM" ? "FEMS" : "BEMS"}`}
            />
          </Stack>
          <CustomAgGrid
            rows={assetMaintenancedata}
            columns={historicalAssetColDefs}
            isEnableView={false}
            setGridApi={setGridApi}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
          />
        </TabPanel>
        <TabPanel value="3">
          <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ width: '100%' }}>
            <Box></Box>
            <RefreshExportButtons
              exportFunction={fetchAuditTrailExportdata}
              exportData={auditTrail}
              refData={gridApi}
              handleRefresh={handleRefreshAuditTrail}
              title={`Asset Audit Trail ${assetCategoryType === "/assetsFEM" ? "FEMS" : "BEMS"}`}
            />
          </Stack>
          <CustomAgGrid rows={auditTrail} columns={assetAuditColDefs} setGridApi={setGridApi} />
        </TabPanel>

        <TabPanel value="6">
          <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ width: '100%' }}>
            <Box></Box>
            <RefreshExportButtons
              exportFunction={fetchcontracthistoryExportdata}
              exportData={contracthistory}
              refData={gridApi}
              handleRefresh={handleRefreshAuditTrail}
              title={`Asset Audit Trail ${assetCategoryType === "/assetsFEM" ? "FEMS" : "BEMS"}`}
            />
          </Stack>
          <CustomAgGrid rows={contracthistory} columns={contracthistoryColDef} setGridApi={setGridApi} />
        </TabPanel>
        {/* <TabPanel value="6">
          <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ width: '100%' }}>
            <Box></Box>
            <RefreshExportButtons
              exportFunction={fetchcontracthistoryExportdata}
              exportData={contrcthistory}
              refData={gridApi}
              handleRefresh={handleRefreshMaintananceHistory}
              title={`Contract History ${assetCategoryType === "/assetsFEM" ? "FEMS" : "BEMS"}`}
            />
          </Stack>

          <CustomAgGrid
            rows={contrcthistory}
            columns={contracthistoryColDef}
            setGridApi={setGridApi} />
        </TabPanel> */}

      </TabContext>
      <Dialog
        open={openDialog}
        onClose={(event, reason) => {
          if (reason === "backdropClick") {
            // Prevent closing the dialog on backdrop click
            return;
          }
          handleCloseDialog();
        }}
        disableEscapeKeyDown
      >
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <CustomSelectInput
                options={maintananceYearOptions}
                modal={openDialog}
                name="historicalmaintenanceyear"
                label="Maintenance Cost Year"
                value={textfield?.historicalmaintenanceyear || ''}
                onChange={handleOnchangeforCustomfield}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <CustomTextField
                label="Break Down Cost in RM"
                value={textfield?.breakdowncost || ''}
                name="breakdowncost"
                onChange={handleOnchangeforCustomfield}
                allowDecimal={true}
                numbersLength={13}
                textAlign='right'
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <CustomTextField
                label="PPM Cost in RM"
                value={textfield?.ppmcost || ''}
                name="ppmcost"
                onChange={handleOnchangeforCustomfield}
                allowDecimal={true}
                numbersLength={13}
                textAlign='right'
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <CustomTextField
                label="Total Maintenance Cost"
                value={parseFloat(textfield?.totalmaintenancecost || 0)?.toFixed(2) || ""}
                name="totalmaintenancecost"
                onChange={handleOnchangeforCustomfield}
                disabled
                textAlign='right'
              />
            </Grid>
            {/* <Grid item xs={12} md={6}>
              <CustomTextField
                label="Document Serial No"
                value={textfield?.documentSerialNo || ''}
                onlyNumbers={true}
                name="documentSerialNo"
                onChange={handleOnchangeforCustomfield}
              />
            </Grid> */}
            <Grid item xs={12} md={6}>
              <CustomTextField
                label="Remarks"
                value={textfield?.remarks || ''}
                //onlyNumbers={true}
                name="remarks"
                onChange={handleOnchangeforCustomfield}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button disabled={disableAddbtn} onClick={formSubmit} variant="contained" autoFocus>
            {selectedRow ? "UPDATE" : "ADD"}
          </Button>
          <Button onClick={handleCloseDialog}>Cancel</Button>
        </DialogActions>
      </Dialog>

      <CustomDialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
        onConfirm={confirmDelete}
        title="Confirm Delete"
        content="Are you sure you want to delete this history?"
        cancelBtn='Cancel'
        confirmBtn='Delete'
      />
      <CustomDialog
        open={!!errorMessage}
        onClose={() => setErrorMessage("")}
        onConfirm={() => setErrorMessage("")}
        title="Warning !"
        content={errorMessage}
        cancelBtn="Cancel"
        confirmBtn="Ok"
      />
    </Box>
  );
}

export default AssetRecordTab;
